import React from 'react';
import { useAuth } from '../../context/AuthContext';


const LogoutButton = () => {
  const { softLogout } = useAuth();

  const handleLogout = () => {
    softLogout();
  };

  return (
    <button className='logout' onClick={handleLogout}>Logout</button>
  );
};

export default LogoutButton;
